/* src/app/job-signoff-workshop/partials/job-signoff-workshop-manager/job-signoff-workshop-manager.component.scss */
/*# sourceMappingURL=job-signoff-workshop-manager.component.css.map */
